import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, BookOpen, Pill, Gift, Zap } from 'lucide-react';
const bonuses = [{
  label: 'BONO 1',
  title: 'Lista de Compras Inteligente',
  desc: 'Ingredientes clave que encuentras en cualquier país para facilitar tu nutrición metabólica.',
  value: '$17',
  icon: <ShoppingBag size={24} className="text-sage-700" data-id="element-40" />,
  image: 'https://cdn.magicpatterns.com/uploads/q6uXNA6shmTNwhaqYQryqH/mockup_Bono_1.png'
}, {
  label: 'BONO 2',
  title: 'Diario de Síntomas de 7 Días',
  desc: 'Una herramienta poderosa para identificar tus disparadores personales y medir tu progreso.',
  value: '$24',
  icon: <BookOpen size={24} className="text-sage-700" data-id="element-41" />,
  image: 'https://cdn.magicpatterns.com/uploads/xkKB6cFaTNwdxtfdwvXehe/Mockup_Bono_2.png'
}, {
  label: 'BONO 3',
  title: 'Guía de Suplementos que SÍ funcionan',
  desc: 'No tires más tu dinero. Conoce exactamente qué comprar, qué dosis y cuándo tomarlo.',
  value: '$29',
  icon: <Pill size={24} className="text-sage-700" data-id="element-42" />,
  image: 'https://cdn.magicpatterns.com/uploads/4py6boza3Q1Cpc2rrfBi2U/Mockup_Bono3.png'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function BonusesSection() {
  return <section className="py-20 md:py-32 bg-sage-800 text-cream relative overflow-hidden" data-id="element-43">
      {/* Decorative background */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-sage-700 rounded-full mix-blend-overlay filter blur-3xl opacity-50 pointer-events-none" data-id="element-44"></div>
      <div className="absolute bottom-10 right-10 w-72 h-72 bg-sage-600 rounded-full mix-blend-overlay filter blur-3xl opacity-30 pointer-events-none" data-id="element-45"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        {/* Header with strong value framing */}
        <div className="text-center mb-16 max-w-4xl mx-auto" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-cream/10 border border-cream/20 backdrop-blur-sm rounded-full px-5 py-2 mb-8" data-id="element-48">
            <Zap size={16} className="text-yellow-400 fill-yellow-400" data-id="element-49" />
            <span className="text-cream text-xs md:text-sm font-semibold tracking-widest uppercase" data-id="element-50">
              Solo por tiempo limitado
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex justify-center mb-6" data-id="element-51">
            <div className="w-20 h-20 bg-cream/10 border-2 border-cream/30 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-52">
              <Gift size={36} className="text-cream" data-id="element-53" />
            </div>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 text-cream leading-tight" data-id="element-54">
            Si ordenas <span className="italic text-yellow-300" data-id="element-55">HOY</span>,
            <br data-id="element-56" />
            te llevas estos 3 Regalos
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col sm:flex-row items-center justify-center gap-3 text-lg md:text-xl" data-id="element-57">
            <span className="text-sage-100/90" data-id="element-58">Valorados en</span>
            <span className="bg-cream text-sage-800 font-bold px-4 py-1 rounded-full text-xl md:text-2xl line-through opacity-70" data-id="element-59">
              $70 USD
            </span>
            <span className="text-yellow-300 font-bold text-2xl md:text-3xl tracking-wider" data-id="element-60">
              GRATIS
            </span>
          </motion.div>
        </div>

        {/* Bonus Cards */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-12" data-id="element-61">
          {bonuses.map((bono, index) => <motion.div key={index} variants={itemVariants} whileHover={{
          y: -6
        }} className="bg-cream text-charcoal rounded-2xl overflow-hidden relative flex flex-col shadow-xl group transition-shadow hover:shadow-2xl" data-id="element-62">
              {/* Image */}
              <div className="relative bg-sage-100/40 aspect-[4/3] overflow-hidden flex items-center justify-center p-4" data-id="element-63">
                <img src={bono.image} alt={bono.title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-64" />
                <div className="absolute top-3 right-3 bg-sage-800 text-cream text-xs font-bold px-3 py-1 rounded-full tracking-wider" data-id="element-65">
                  {bono.label}
                </div>
                {/* Free badge */}
                <div className="absolute top-3 left-3 bg-yellow-300 text-sage-800 text-xs font-extrabold px-3 py-1 rounded-full tracking-wider shadow-md" data-id="element-66">
                  GRATIS
                </div>
              </div>

              {/* Content */}
              <div className="p-7 flex flex-col flex-grow" data-id="element-67">
                <div className="w-10 h-10 bg-sage-100 rounded-full flex items-center justify-center mb-4" data-id="element-68">
                  {bono.icon}
                </div>

                <h3 className="text-xl font-bold mb-3 leading-tight" data-id="element-69">
                  {bono.title}
                </h3>
                <p className="text-charcoal-light text-sm mb-6 leading-relaxed flex-grow" data-id="element-70">
                  {bono.desc}
                </p>

                <div className="mt-auto pt-4 border-t border-sage-100 flex items-center justify-between" data-id="element-71">
                  <span className="text-sm text-charcoal-light" data-id="element-72">
                    Valor: <span className="line-through" data-id="element-73">{bono.value}</span>
                  </span>
                  <span className="font-bold text-sage-700 uppercase text-sm tracking-wide" data-id="element-74">
                    Incluido
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Value summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream/5 border border-cream/15 backdrop-blur-sm rounded-2xl p-6 md:p-8 max-w-2xl mx-auto" data-id="element-75">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-cream" data-id="element-76">
            <div className="text-center sm:text-left" data-id="element-77">
              <p className="text-sage-100/80 text-sm uppercase tracking-widest mb-1" data-id="element-78">
                Valor total de los bonos
              </p>
              <p className="text-3xl md:text-4xl font-bold" data-id="element-79">
                <span className="line-through opacity-50" data-id="element-80">$70</span>{' '}
                <span className="text-yellow-300" data-id="element-81">$0</span>{' '}
                <span className="text-base font-normal text-sage-100/80" data-id="element-82">
                  USD
                </span>
              </p>
            </div>
            <div className="text-center sm:text-right" data-id="element-83">
              <p className="text-yellow-300 font-bold text-lg md:text-xl tracking-wide" data-id="element-84">
                100% GRATIS
              </p>
              <p className="text-sage-100/70 text-xs uppercase tracking-widest mt-1" data-id="element-85">
                Al ordenar hoy
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}